module.exports =
  '_PAID_INTRO':
    'PAGE_TITLE': 'GOLF NETWORK PLUS'
    'TITLE': 'より充実した機能で、自分の実力を分析しよう！'
    'SUB_TITLE': 'この機能をお使いいただくには、有料会員への登録が必要です。'
    'FEE': '有料会員(月額５００円)にご登録いただくと、より詳細なスコア分析／コース分析を利用できます。'
    'SETTING': '目標値の設定'
    'SETTING_CONTENT': '目標を明確にすることが上達への近道、個人の目標データを入力しましょう。'
    'COMPATION': 'コース別スコアの比較'
    'COMPATION_CONTENT': '個人のラウンド結果やコース平均との比較ができます。'
    'PC': 'ＰＣからのスコア編集'
    'PC_CONTENT': 'モバイルアプリで入力してスコアデータを後からＰＣで編集することも可能です。'
    'ENSURE': 'この機能をお使いいただくには、有料会員への登録が必要です。'
    'REGISTER': '有料会員に登録する'
    'BTN_TITLE': '有 料 会 員 に な る'
    'BTN_NOTE': '月額５００円 (税抜)'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/paid-introduction/i18n/ja.coffee